import { isDevEnv, isSitEnv } from '../../../system/service/CspConfigService';

const showCommandPalette = process.env.NX_PUBLIC_HIDE_COMMAND_PALETTE !== 'true';

export const canToggleCommandPalette = (): boolean => (isDevEnv() || isSitEnv()) && showCommandPalette;
